import { CategoryConfig, ProcessConfig } from './../models/config.model';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";


@Component({
    selector: 'app-total-statistic',
    templateUrl: './total-statistic.component.html',
    // styleUrls: ['./total-statistic.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class TotalStatisticComponent {
    @Input() category: CategoryConfig;
    @Input() process: ProcessConfig;
}